import { HeroSection } from '../components/home/HeroSection';
import { AboutSection } from '../components/home/AboutSection';
import { CounterSection } from '../components/home/CounterSection';
import { ClientsLogoSection } from '../components/home/ClientsLogoSection';
import { HighlightVideosSection } from '../components/home/HighlightVideosSection';
import { CTASection } from '../components/home/CTASection';
import { ProgramsSection } from '../components/home/ProgramsSection';
import { ServicesPreviewSection } from '../components/home/ServicesPreviewSection';
import { EventPhotosSection } from '../components/home/EventPhotosSection';
import { TestimonialsSection } from '../components/home/TestimonialsSection';
import { IndustriesSection } from '../components/home/IndustriesSection';
import SEO from '../components/SEO';

export const HomePage = () => {
  return (
    <main data-testid="home-page">
      <SEO 
        title="World-Class Event Management & International Awards"
        description="Golden Tree Events is Dubai's leading international event management company. We organize world-class exhibitions, summits, conferences, awards ceremonies, and business networking platforms across 50+ countries."
        keywords="event management Dubai, international awards, business conferences, exhibitions, summits, Golden Tree Events, corporate events UAE"
      />
      <HeroSection />
      <CounterSection />
      <AboutSection />
      <ClientsLogoSection />
      <HighlightVideosSection />
      <CTASection 
        title="Ready to Create Something Extraordinary?"
        subtitle="Let's bring your vision to life with world-class event management"
        primaryCta={{ text: "Get a Quote", link: "/contact-us" }}
        secondaryCta={{ text: "Our Services", link: "/services" }}
      />
      <ProgramsSection />
      <ServicesPreviewSection />
      <EventPhotosSection />
      <TestimonialsSection />
      <CTASection 
        title="Partner With Us for Your Next Event"
        subtitle="Join 20,000+ global brands who trust Golden Tree Events"
        primaryCta={{ text: "Contact Us", link: "/contact-us" }}
        secondaryCta={{ text: "View Gallery", link: "/gallery" }}
      />
      <IndustriesSection />
    </main>
  );
};

export default HomePage;
